<template>
    <section container>
        <section banner style="position: relative; height: auto; overflow: hidden;" v-if="banner.id">
            <div cover class="d-block" style="position: relative;" v-if="banner.assets">
                <img :src="banner.assets" style="min-height: 300px !important;">
            </div>
            <div content class="d-block" style="width: 72.5%;">
                <h1 class="b-title">{{ banner.title }}</h1>
                <h1 class="b-desc">{{ banner.desc }}</h1>
            </div>
        </section>

        <section content padding v-if="banner.content">
            <div data-box="article" class="d-block" v-html="banner.content"/>
        </section>

        <section content padding v-if="info.id">
            <div class="d-block align-center">
                <h1 class="size-40">{{ $common.config.lang === 'cn' ? '公司简介' : 'Company profile' }}</h1>
            </div>
            <br>
            <div data-box="article" class="d-block" v-html="info.content"/>
        </section>

        <section content padding v-if="story.id">
            <div class="d-block align-center">
                <h1 class="size-40">{{ $common.config.lang === 'cn' ? '业务范围' : 'Business scope' }}</h1>
            </div>
            <br>
            <div data-box="article" class="d-block" v-html="story.content"/>
        </section>

        <section content padding v-if="certs.length > 0">
            <div class="d-block align-center">
                <h1 class="size-40">{{ $common.config.lang === 'cn' ? '荣誉资质' : 'Honor and qualification' }}</h1>
            </div>
            <br>
            <Row>
                <Col :xs="24" :sm="12" :md="12" :lg="8" v-for="(it, i) in certs" :key="i">
                    <div class="public-shell" margin>
                        <div class="photo-view rectangle" style="padding-top: calc((100% / 9) * 12);">
                            <img :preview="new Date().getTime()" :src="it.certCover"/>
                        </div>
                        <br/>
                        <h2>
                            <a :target="it.certLink ? '_blank' : false" :href="it.certLink ? it.certLink : false">{{ it.certName }}</a>
                        </h2>
                    </div>
                </Col>
            </Row>
        </section>

        <section padding v-if="contact.id">
            <div class="d-block align-center">
                <h1 class="size-40">{{ $common.config.lang === 'cn' ? '联系我们' : 'Contact US' }}</h1>
            </div>
            <br>
            <div class="d-block">
                <baidu-map ref="mapContainer" :center="marker" :zoom="zoom" :auto-resize="false" :scroll-wheel-zoom="true" @ready="mapReady" style="width: 100%; height: 400px;">
                    <!-- 标记点 -->
                    <bm-marker :position="{lng: marker.lng, lat: marker.lat}" :icon="{url: marker.icon, size: {width: 44, height: 44} }" :dragging="false"/>
                    <!-- 信息窗体 -->
                    <bm-info-window :show="true" :position="{ lng: marker.lng, lat: marker.lat}" :width="360" :closeOnClick="false">
                        <div class="d-block">
                            <div class="d-block pb-sm">
                                <h2>{{ contact.orgName }}</h2>
                                <hr/>
                                <h3>{{ contact.orgAddr }}</h3>
                            </div>
                        </div>
                    </bm-info-window>
                </baidu-map>
            </div>
        </section>

        <section content padding v-if="contact.id">
            <Row>
                <Col :xs="1" :sm="1" :md="1" :lg="6">&nbsp;</Col>
                <Col :xs="22" :sm="22" :md="22" :lg="12">
                    <h1>{{ contact.orgName }}</h1>
                    <br/>
                    <div class="d-flex justify-start mb-sm">
                        <span class="d-flex justify-center square-48 radius-all bd-1 b-primary">
                            <Icon class="c-primary" type="ios-pin" size="28"/>
                        </span>
                        <h2 class="d-flex-item ml-md">{{ contact.orgAddr }}</h2>
                    </div>
                    <div class="d-flex justify-start mb-sm">
                        <span class="d-flex justify-center square-48 radius-all bd-1 b-primary">
                            <Icon class="c-primary" type="ios-call" size="28"/>
                        </span>
                        <h2 class="d-flex-item ml-md">{{ contact.orgTel }}</h2>
                    </div>
                    <div class="d-flex justify-start">
                        <span class="d-flex justify-center square-48 radius-all bd-1 b-primary">
                            <Icon class="c-primary" type="ios-mail" size="28"/>
                        </span>
                        <h2 class="d-flex-item ml-md">{{ contact.orgEmail }}</h2>
                    </div>
                </Col>
                <Col :xs="1" :sm="1" :md="1" :lg="6">&nbsp;</Col>
            </Row>
            <br/>
        </section>
    </section>
</template>

<style type="text/css">
    .anchorBL{display: none;}
</style>

<script type="text/javascript">
    export default {
        data() {
            return {
                banner: {},
                info: {},
                story: {},
                certs: [],
                contact: {},

                zoom: 13, // 缩放等级
                marker: {
                    lng: 116.322661,
                    lat: 40.047995,
                    icon: 'static/icon/map-marker-error@44px.png',
                },
            }
        },
        async created() {
        },
        async mounted() {
            await this.getAbout();
        },
        methods: {
            async getAbout(){
                let res = await this.$api.getHttp('about/query?lang=' + this.$common.config.lang);
                console.log('this.getAbout---------->', res);
                let data = res.data.data || [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].type === 1){
                        this.banner = data[i];
                    }
                    if (data[i].type === 2){
                        this.info = data[i];
                    }
                    if (data[i].type === 3){
                        this.story = data[i];
                    }
                    if (data[i].type === 4){
                        this.certs.push(data[i]);
                    }
                    if (data[i].type === 5){
                        this.contact = data[i];
                    }
                }
            },

            async mapReady({BMap, map}) {
                // map.disableDragging(); //禁止拖动
                // map.disableScrollWheelZoom(); //禁止缩放
                map.disableDoubleClickZoom(); //禁止双击缩放
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/about/index.vue